"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DELAY_BEFORE_REMOVE_MSEC = exports.DELAY_BEFORE_REMOVE_MSEC = 1000;